import React, { useEffect } from 'react';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
import { init } from '@elastic/apm-rum';
import { ENV } from 'utils/env';
import './i18n';

export const InitialiseThirdParties: React.FunctionComponent = () => {
    useEffect(() => {
        Sentry.init({
            dsn: ENV.SENTRY_DSN,
            integrations: [
                new Integrations.BrowserTracing(),
                new Sentry.Integrations.Breadcrumbs(),
            ],
            tracesSampleRate: 1.0,
            environment: ENV.APP_ENV,
        });
    }, []);

    useEffect(() => {
        if (ENV.ELASTIC_APM_ACTIVE) {
            init({
                active: ENV.ELASTIC_APM_ACTIVE,
                environment: ENV.ELASTIC_APM_ENVIRONMENT,
                serviceName: ENV.ELASTIC_APM_SERVICE_NAME,
                serverUrl: ENV.ELASTIC_APM_SERVER_URL,
                serviceVersion: ENV.APP_VERSION,
            });
        }
    }, []);

    return null;
};

export default InitialiseThirdParties;
